import api from '../../mdms_api';

export default async (publication_id) => {
  const response = await api.get(`/api/v1/dms/meta/${publication_id}`)
  return response.ok ? await response.json() : null;
};
